import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { publishOAuthMessage } from '../utils/metaOauthMessage';

// Rota SPA que recebe o retorno do OAuth da Meta quando o callback cai sem
// window.opener (a Meta/Chrome abriu o retorno em aba própria, ou o opener foi
// perdido na navegação cross-origin). A janela de origem espera o code pelo
// BroadcastChannel/localStorage (mesma origem) — ver subscribeMetaOAuth em
// utils/metaOauthMessage.ts e o uso em MetaEmbeddedSignup.handleLaunchSignup.
// Tenta fechar a janela quando possível; se o navegador bloquear o close (ex.:
// aba que não foi aberta por script), mostra um aviso mínimo.
const MetaCallback: React.FC = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state') || '';
    const hasError = searchParams.has('error') || searchParams.has('error_code');

    if (code) {
      publishOAuthMessage({ type: 'META_ES_CODE', code, state });
    } else if (hasError || !state) {
      publishOAuthMessage({ type: 'META_ES_CANCEL', state });
    }

    try {
      window.close();
    } catch {
      // close bloqueado — mantém o aviso em tela
    }
  }, [searchParams]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4 dark:bg-slate-900">
      <div className="max-w-sm rounded-lg border border-gray-200 bg-white p-6 text-center shadow-sm dark:border-slate-800 dark:bg-slate-800">
        <p className="text-sm text-gray-600 dark:text-gray-300">Login with Meta done — you can close this tab and return to SinTicket.</p>
      </div>
    </div>
  );
};

export default MetaCallback;